// What this project allows (GET /embed/v1/project/policies): its default
// visibility for new files, how copies are made, its upload limits. Read
// once and shared by every dialog for a minute — an admin's change in the
// console reaches an open page within that, a reload at once. A failed read
// leaves the dialogs on docs' usual behaviour (Private).

import { useEffect, useState } from 'react';
import { auth } from '../utils/auth';
import baseAxios from '../utils/request';
import { PROJECT_POLICIES } from '../utils/urls.js';

const TTL_MS = 60_000;
let cached = null; // { at, promise }

export function fetchProjectPolicies() {
  if (!cached || Date.now() - cached.at > TTL_MS) {
    const promise = baseAxios({ method: 'GET', url: PROJECT_POLICIES, headers: auth().headers })
      .then((res) => res.data)
      .catch(() => {
        cached = null;
        return null;
      });
    cached = { at: Date.now(), promise };
  }
  return cached.promise;
}

export function useProjectPolicies() {
  const [policies, setPolicies] = useState(null);
  useEffect(() => {
    let live = true;
    fetchProjectPolicies().then((value) => {
      if (live) setPolicies(value);
    });
    return () => {
      live = false;
    };
  }, []);
  return policies;
}

/** The visibility a new file gets when its creator doesn't choose. */
export function useProjectDefaultVisibility() {
  return useProjectPolicies()?.policies?.visibility?.default || 'private';
}
